import { useMemo } from "react"

import { useTranslation } from "react-i18next"

import Table from "../../../../../Components/Table"
import { CASE_OUTCOME } from "../../constants/outcomes"
import { getColumns } from "../CaseLookupTable/columns"

import styles from "./styles.module.less"

const GHOST_OUTCOMES = Object.values(CASE_OUTCOME)

const buildGhostRows = () => {
  const now = Date.now()
  return Array.from({ length: 7 }, (_, i) => ({
    id: `ghost-${i}`,
    date: new Date(now - (i + 1) * 24 * 60 * 60 * 1000).toISOString(),
    card: String(2000 + i * 111).slice(-4),
    program: i % 2 === 0 ? "ce" : "fpt",
    outcome: GHOST_OUTCOMES[i % GHOST_OUTCOMES.length],
    amount: 50 + i * 45.75,
    fee_charged: null
  }))
}

const CaseGhostTable = ({ activeColumns }) => {
  const { t } = useTranslation()
  const columnMap = getColumns({ t })
  const ghostRows = useMemo(buildGhostRows, [])

  const cols = activeColumns
    .filter((c) => c.active !== false)
    .map((c) => columnMap[c.field_id])
    .filter(Boolean)

  return (
    <div className={styles.ghost} aria-hidden="true">
      <Table
        dataSource={ghostRows}
        columns={cols}
        rowKey="id"
        pagination={false}
        withOutPagination
      />
    </div>
  )
}

export default CaseGhostTable
